
export const NOTIFICATION_SEND = 'NOTIFICATION_SEND';
export const NOTIFICATION_SEND_USER = 'NOTIFICATION_SEND_USER';
export const NOTIFICATION_SEND_CLASS = 'NOTIFICATION_SEND_CLASS';
export const NOTIFICATION_SEND_EXTRACURRICULAR_ACTIVITY = 'NOTIFICATION_SEND_EXTRACURRICULAR_ACTIVITY';
export const NOTIFICATION_GET_ALL = 'NOTIFICATION_GET_ALL';
export const NOTIFICATION_DETAILS = 'NOTIFICATION_DETAILS';
export const NOTIFICATION_GET_USER = 'NOTIFICATION_GET_USER';
export const NOTIFICATION_READ = 'NOTIFICATION_READ'